e4.product = {
    debug: false,
    init: function () {
        if (jQuery('.js-e-product-form, .js-e-productlist').length > 0) {
            e4.require.js(e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                // Variants is not yet ready for production.
                // e4.product.variants.init();
            });
        }
        jQuery('.js-e-product-images, #js-e-product-image-modal').on('loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function (event) {
            jQuery(event.target).on('mouseenter', '.carousel-indicators li', function (event) {
                jQuery(event.target).trigger('click');
            });
            e4.product.initializeSlider();
        });

    },
    bindEvents: function () {
        jQuery('.js-e-product-form').each(function (intIndex, domForm) {
            e4.product.validateForm(domForm);
        });
        jQuery('.js-e-productlist').on('builded.e4.productlist', function (event) {
            jQuery(event.target).find('.js-e-product-form').each(function (intIndex, domForm) {
                e4.product.validateForm(domForm);
            });
        });
        if (jQuery('.js-e-product-favorite-list-form').length > 0) {
            e4.product.favoritelist.bindEvents();
        }
        e4.product.prefillQuoteFormProductField();
        e4.product.quantityControls();
    },
    validateForm: function (domForm) {
        var jForm = jQuery(domForm);
        jForm.validate({
            submitHandler: function (domForm) {
                if (jForm.is('.js-e-product-form-removefromcart') === true) {
                    e4.product.removeFromCart(domForm);
                } else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart(domForm);
                }
            }
        });
    },
    addToCart: function (domForm) {
        var jForm = jQuery(domForm),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        
        for (var i = 0; i < arrFormData.length; i++) {
            objFormData[arrFormData[i].name] = arrFormData[i].value;
            
        }
        jQuery.extend(objFormData, {
            Redirect: false
        });
        if (jForm.is('.js-e-product-form-download') === true) {
            e4.download.cart.addProduct(objFormData);
        } else {
            e4.cart.addProduct(objFormData);
        }
    },
    removeFromCart: function (domForm) {
        var jForm = jQuery(domForm),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for (var i = 0; i < arrFormData.length; i++) {
            objFormData[arrFormData[i].name] = arrFormData[i].value;
        }
        jQuery.extend(objFormData, {
            Redirect: false
        });
        if (jForm.is('.js-e-product-form-download') === true) {
            e4.download.cart.removeProduct(objFormData);
        } else {
            e4.cart.removeProduct(objFormData);
        }
    },
    favoritelist: {
        bindEvents: function () {
            jQuery('.js-e-product-favorite-list-form').on('submit', function (event) {
                event.preventDefault();
            }).on('change', '.js-e-favorite-list', function (event) {
                e4.product.favoritelist.toggleList(event.target);
            });
        },
        toggleList: function (domInput) {
            var jInput = jQuery(domInput);
            if (jInput.prop('checked') === true) {
                e4.product.favoritelist.addToList(jInput);
            } else {
                e4.product.favoritelist.removeFromList(jInput);
            }
        },
        addToList: function (jInput) {
            jInput.prop('disabled', true);
            e4.cc.ajax({
                url: jInput.data('url-add') + '&Redirect=false'
            }, function () {
                jInput.prop('disabled', false);
            });
        },
        removeFromList: function (jInput) {
            jInput.prop('disabled', true);
            e4.cc.ajax({
                url: jInput.data('url-remove') + '&Redirect=false'
            }, function () {
                jInput.prop('disabled', false);
            });
        }
    },
    initializeSlider: function () {
        jQuery('.js-lightslider').lightGallery({
            zoom: true,
            scale: 0.5,
            thumbnail: true,
            showThumbByDefault: true,
            toogleThumb: false,
            hideBarsDelay: 0
        });
    },
    prefillQuoteFormProductField: function () {
        var productNumber = jQuery('.js-product-number').html();
        jQuery('.js-product-prefill').val(productNumber);
    },
    quantityControls: function () {
        var jCart = jQuery('.js-e-cart');
        var updateTimeout = null;
        jQuery(document).on('click', '.js-decrement-quantity', function (event) {
            clearTimeout(updateTimeout);
            var input = jQuery(event.target).siblings('input');
            var step = parseInt(input.attr('step'));
            var value = parseInt(input.val());
            var min = parseInt(input.attr('min'));
            var newValue = value - step;
            if (newValue >= min) {
                input.val(newValue);
            }
            
            if (jCart.length === 1) {
                
                updateTimeout = setTimeout(function () {
                    e4.cart.orderline.update(event.target);
                }, e4.settings.ecom.cart.debounceDelay);

            }
        });

        jQuery(document).on('click', '.js-increment-quantity', function (event) {
            clearTimeout(updateTimeout);
            var input = jQuery(event.target).siblings('input');
            var step = parseInt(input.attr('step'));
            var value = parseInt(input.val());
            //var max = parseInt(input.attr('max'));
            var newValue = value + step;
            input.val(newValue).trigger('input');

            
            
            var jForm = jQuery(event.target).closest('.js-adjust-quantity');
            var intUnitsPerBox = parseInt(jForm.data('unitsPerBox'));

            jForm.find('.js-real-quantity').val(intUnitsPerBox > 1 ? (newValue / intUnitsPerBox) : newValue);
            
            if (jCart.length === 1) {
                updateTimeout = setTimeout(function () {
                    e4.cart.orderline.update(event.target);
                }, e4.settings.ecom.cart.debounceDelay);
            }

        });

    }
};
